import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import TableRow, { TableRowProps } from '@material-ui/core/TableRow';

import { TableCellProps, TableCell } from './TableCell';
import { Typography } from './Typography';

const messages = defineMessages({
  emptyStateWithFilters: {
    id: 'embeds.components.TableRowEmptyState.emptyState',
    defaultMessage: 'Try adjusting your filters to view more results',
  },
});

export interface TableRowEmptyStateProps extends TableRowProps {
  colSpan: TableCellProps['colSpan'];
}

export const TableRowEmptyState: React.FC<TableRowEmptyStateProps> = ({ colSpan, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <TableRow {...rest}>
      <TableCell variant="emptyState" colSpan={colSpan}>
        <Typography variant="body1">
          <i>{formatMessage(messages.emptyStateWithFilters)}</i>
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default TableRowEmptyState;
